// extracted by mini-css-extract-plugin
module.exports = {"navbar_root":"navbar_navbar_root__2o8rb"};